import { render, staticRenderFns } from "./residents-vital-signs-list.vue?vue&type=template&id=4d7dcf01&scoped=true&"
import script from "./residents-vital-signs-list.vue?vue&type=script&lang=js&"
export * from "./residents-vital-signs-list.vue?vue&type=script&lang=js&"
import style0 from "./residents-vital-signs-list.vue?vue&type=style&index=0&id=4d7dcf01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7dcf01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VTextField})
